import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-902d1492"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "block"
}
const _hoisted_3 = {
  key: 0,
  class: "nav-list-item",
  role: "none"
}

import { NavigationItemModel } from '@/types/B2CcontentServerContract';
import navigationStore from '@/shared/navigation/navigation.store';
import useNavigationRenderer from '@/shared/navigation/site-navigation/useNavigationRenderer';
import { computed, defineAsyncComponent } from 'vue';
import LogoutLink from '@/shared/navigation/LogoutLink.vue';
import useProfile from '@/shared/navigation/site-navigation/useProfile';
import navigationTrackingService from '@/shared/tracking/navigation-tracking.service';
import useKeepNavigationItemInView from '@/shared/navigation/site-navigation/useKeepNavigationItemInView';

export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationRenderer',
  props: {
    items: { default: undefined },
    depthIndex: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { items: NavigationItemModel[], depthIndex: number }

const MainNavigationItemLabel = defineAsyncComponent(() => import('@/shared/navigation/site-navigation/MainNavigationItemLabel.vue'));



const { toggleSelectedItem, getIsSelectedItem, getSelectedItemByIndex, getHasSubItems, getMaybeNavigableComponentNameFromItem } = useNavigationRenderer();
const { profileLinks, accountName, shouldShowLogout } = useProfile();
const { addItem, maybeScrollToItem } = useKeepNavigationItemInView();

const nextDepthIndex = computed<number>(() => props.depthIndex + 1);

const shouldShowMyBoliaLinks = computed<boolean>(() => {
    if (props.depthIndex !== 1) {
        return false;
    }
    const randomItemOfType = props.items[0];
    return navigationStore.getIsMyBoliaItem(randomItemOfType);
});

const controlledById = () => {
    const toggledByItem = getSelectedItemByIndex(props.depthIndex - 1);

    if (!toggledByItem) return null;

    const toggledById = toggledByItem?.id;
    const toggledByParentId = toggledByItem?.parentId;
    return `${toggledByParentId}-${toggledById}`;
};

const getShouldShowAccountName = (item: NavigationItemModel): boolean => {
    if (props.depthIndex !== 0) {
        return false;
    }
    return navigationStore.getIsMyBoliaItem(item);
};

const getAriaControlsId = (item: NavigationItemModel) => {
    const value = `${item.parentId}-${item.id}`;
    return item.items ? value : null;
};

const getAriaExpandedState = (item: NavigationItemModel, i: number) => {
    return item.items ? getIsSelectedItem(item, i) : null;
};

const getAriaHasPopup = (item: NavigationItemModel) => {
    return item.items ? 'menu' : null;
};


return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!
  const _component_NavigationRenderer = _resolveComponent("NavigationRenderer", true)!
  const _component_RouterLinkConditional = _resolveComponent("RouterLinkConditional")!

  return (__props.items?.length)
    ? (_openBlock(), _createElementBlock("ul", {
        key: 0,
        id: controlledById(),
        class: "nav-list",
        role: "menu"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, idx) => {
          return (_openBlock(), _createElementBlock("li", {
            ref_for: true,
            ref: el => _unref(addItem)(el, idx),
            key: item.name+idx,
            role: "none",
            class: _normalizeClass(["nav-list-item", {'cursor-pointer': item.url || _unref(getHasSubItems)(item)}])
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(getMaybeNavigableComponentNameFromItem)(item)), {
              to: item.url,
              title: item.name,
              "spa-enabled": item.spaLink,
              "aria-expanded": getAriaExpandedState(item, __props.depthIndex),
              "aria-owns": getAriaControlsId(item),
              "aria-haspopup": getAriaHasPopup(item),
              role: "menuitem",
              target: item.target,
              onClickPassive: ($event: any) => (_unref(toggleSelectedItem)(item, __props.depthIndex))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name) + " ", 1),
                (item.label)
                  ? (_openBlock(), _createBlock(_unref(MainNavigationItemLabel), {
                      key: 0,
                      label: item.label
                    }, null, 8, ["label"]))
                  : _createCommentVNode("", true),
                (_unref(getHasSubItems)(item))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_c_icon, {
                        name: "icon-minus-medium",
                        "aria-hidden": "true",
                        class: "icon"
                      }),
                      _createVNode(_component_c_icon, {
                        name: "icon-minus-medium",
                        "aria-hidden": "true",
                        class: _normalizeClass(["icon transition-all duration-300", {'rotate-0 opacity-0': _unref(getIsSelectedItem)(item, __props.depthIndex), 'rotate-90': !_unref(getIsSelectedItem)(item, __props.depthIndex)}])
                      }, null, 8, ["class"])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1064, ["to", "title", "spa-enabled", "aria-expanded", "aria-owns", "aria-haspopup", "target", "onClickPassive"])),
            (getShouldShowAccountName(item))
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(accountName)), 1))
              : _createCommentVNode("", true),
            _createVNode(_Transition, {
              name: "o-anim-fade-200",
              onAfterEnter: ($event: any) => (_unref(maybeScrollToItem)(idx))
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_NavigationRenderer, {
                  items: item.items,
                  "depth-index": _unref(nextDepthIndex)
                }, null, 8, ["items", "depth-index"]), [
                  [_vShow, _unref(getIsSelectedItem)(item, __props.depthIndex) && __props.depthIndex < 2]
                ])
              ]),
              _: 2
            }, 1032, ["onAfterEnter"])
          ], 2))
        }), 128)),
        (_unref(shouldShowMyBoliaLinks))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(profileLinks), (item, idx) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.name+idx,
                  role: "none",
                  class: "nav-list-item"
                }, [
                  _createVNode(_component_RouterLinkConditional, {
                    to: item.url,
                    "spa-enabled": item.spaLink,
                    title: item.name,
                    role: 'menuitem',
                    onClickPassive: ($event: any) => (_unref(navigationTrackingService).myBoliaProfileLinks(item))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name) + " ", 1),
                      (item.label)
                        ? (_openBlock(), _createBlock(_unref(MainNavigationItemLabel), {
                            key: 0,
                            label: item.label
                          }, null, 8, ["label"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["to", "spa-enabled", "title", "onClickPassive"])
                ]))
              }), 128)),
              (_unref(shouldShowLogout))
                ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                    _createVNode(LogoutLink, {
                      class: "text-roman hover:text-roman",
                      role: "menuitem",
                      onClickPassive: _cache[0] || (_cache[0] = ($event: any) => (_unref(navigationTrackingService).logoutLink()))
                    })
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})